import React from 'react';
import { Theme, styled, svgIconClasses } from '@mui/material';
import { MUIStyledCommonProps } from '@mui/system';
import { SpinningLoading } from '../animations';
import { LoadingIcon } from '../sizes';
import { Primary } from '../color';

const StyledLi = styled('li')(() => ({
  textAlign: 'center',
  [`.${svgIconClasses.root}`]: {
    ...LoadingIcon,
  },
}));

export interface SelectLoadingIndicatorProps extends
  React.LiHTMLAttributes<HTMLLIElement>,
  MUIStyledCommonProps<Theme> { }

export const SelectLoadingIndicator = ({ sx, ...rest }: SelectLoadingIndicatorProps) => (
  <StyledLi {...rest} sx={{ color: Primary.default.main, ...sx }}>
    <SpinningLoading />
  </StyledLi>
);
